/**
 * /!\ This file is auto-generated.
 *
 * This is the entry point of your standalone application.
 *
 * There are multiple tags used by the editor to inject code automatically:
 *     - `wle:auto-imports:start` and `wle:auto-imports:end`: The list of import statements
 *     - `wle:auto-register:start` and `wle:auto-register:end`: The list of component to register
 */

/* wle:auto-imports:start */
import {AudioSource} from '@wonderlandengine/components';
import {Cursor} from '@wonderlandengine/components';
import {CursorTarget} from '@wonderlandengine/components';
import {FixedFoveation} from '@wonderlandengine/components';
import {HowlerAudioListener} from '@wonderlandengine/components';
import {HowlerAudioSource} from '@wonderlandengine/components';
import {TargetFramerate} from '@wonderlandengine/components';
import {VrModeActiveSwitch} from '@wonderlandengine/components';
import {ArenaHandler} from './arena-handler.js';
import {BoostPurchaseHandler} from './boost-purchase-handler.js';
import {Bot} from './bot.js';
import {GravityCanon} from './gravity-canon.js';
import {KinematicBullet} from './kinematic-bullet.js';
import {Leaderboard} from './leaderboard.js';
import {LevelSync} from './level-sync.js';
import {LobbyHandler} from './lobby-handler.js';
import {FPSMovement} from './movement.js';
import {RemoteWeaponRigManager} from './remote-weapon-rig-manager.js';
import {RifleOrient} from './rifle-orient.js';
import {WeaponSync} from './weapon-sync.js';
/* wle:auto-imports:end */

export default function(engine) {
/* wle:auto-register:start */
engine.registerComponent(AudioSource);
engine.registerComponent(Cursor);
engine.registerComponent(CursorTarget);
engine.registerComponent(FixedFoveation);
engine.registerComponent(HowlerAudioListener);
engine.registerComponent(HowlerAudioSource);
engine.registerComponent(TargetFramerate);
engine.registerComponent(VrModeActiveSwitch);
engine.registerComponent(ArenaHandler);
engine.registerComponent(BoostPurchaseHandler);
engine.registerComponent(Bot);
engine.registerComponent(GravityCanon);
engine.registerComponent(KinematicBullet);
engine.registerComponent(Leaderboard);
engine.registerComponent(LevelSync);
engine.registerComponent(LobbyHandler);
engine.registerComponent(FPSMovement);
engine.registerComponent(RemoteWeaponRigManager);
engine.registerComponent(RifleOrient);
engine.registerComponent(WeaponSync);
/* wle:auto-register:end */
}
